// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

// export const environment = {
//     production: false,
//     isMockEnabled: true, // You have to switch this, when your real back-end is done
//     authTokenKey: 'authce9d77b308c149d5992a80073637e4d5',
//     accesskeyId: 'AKIAIGR2SBDQJRDDFELA',
//     frontUrl: 'http://localhost:4200/', // local
//     frontendUrl: 'http://localhost:4200/', // local
//     baseURL: 'http://localhost:3301/api/v1/', //
//     imgBucketUrl: 'http://localhost:3301/umc-dev',
//     PDFURL: 'http://localhost:3301', // hitesh,
//   };
  
// export const environment = {
//   production: true,
//   isMockEnabled: true, // You have to switch this, when your real back-end is done
//   authTokenKey: 'authce9d77b308c149d5992a80073637e4d5',
//   accesskeyId: 'AKIAIGR2SBDQJRDDFELA',
//   frontUrl: 'https://umcsat.org/frontend', // local
//   frontendUrl: 'https://umcsat.org/backend', // local
//   baseURL: 'https://umcsat.org:3301/api/v1/', //
//   imgBucketUrl: 'https://staging-umc-images.s3.ap-south-1.amazonaws.com',
//   PDFURL: 'https://umcsat.org:3301', // hitesh,
// };
export const environment = {
  production: true,
  isMockEnabled: true, // You have to switch this, when your real back-end is done
  authTokenKey: 'authce9d77b308c149d5992a80073637e4d5',
  accesskeyId: 'AKIAIGR2SBDQJRDDFELA',
  frontUrl: 'https://sanitationmapping.com/', // local
  frontendUrl: 'https://sanitationmapping.com/admin', // local
  baseURL: 'https://sanitationmapping.com:3301/api/v1/', //
  imgBucketUrl: 'https://production-sanitationmapping-image.s3.ap-south-1.amazonaws.com',
  PDFURL: 'https://sanitationmapping.com:3301', // hitesh,
};